exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n    display: grid;\n    grid-template-columns: auto 25px;\n    grid-template-rows: auto 1fr;\n    grid-template-areas: \"header symbol\" \"content content\";\n    padding: 16px;\n    box-sizing: border-box;\n    border-radius: 2px;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),\n    0 1px 5px 0 rgba(0, 0, 0, 0.12),\n    0 3px 1px -2px rgba(0, 0, 0, 0.2);\n}\n\n.paper-header {\n    grid-area: header;\n    font-size: 24px;\n    font-weight: 400;\n    padding: 0 0 10px 0;\n}\n\n.paper-symbol {\n    grid-area: symbol;\n}\n\n.paper-content {\n    grid-area: content;\n    display: grid;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/polymer/paper-card/paper-card.component.css
// module id = ./src/app/components/polymer/paper-card/paper-card.component.css
// module chunks = main